// Builds the recorder state to fall back to when background effects (blur / virtual
// background) fail to load, e.g. WebGL is unavailable or the model host is unreachable
// on a restrictive network. Deselects every background option and turns the effect off
// so the recorder falls back to a plain camera stream instead of a dead preview.
// bgEffectsErrorCount increments on every failure so a UI keyed on it (e.g. a toast) can
// show fresh feedback even if the user already dismissed an earlier one.
export const buildBackgroundEffectsFallbackState = (backgrounds, previousErrorCount = 0) => ({
    backgrounds: backgrounds.map((background) => ({ ...background, selected: false })),
    isBgEnabled: false,
    bgImg: '',
    backgroundBlurAmount: '',
    bgEffectsUnavailable: true,
    bgEffectsErrorCount: previousErrorCount + 1,
});
